module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_null_0.aaff33ab.png";